import { useQuery } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface UserNotificationData {
  notifications: Notification[];
}

export type NotificationType = 'general' | 'clonedObjectSuccess';

export type Notification = {
  uuid: string;
  title: string;
  message: string;
  type: NotificationType;
  data?: Record<string, string>;
};

export function useUserNotifications() {
  const { keycloak } = useKeycloak();

  return useQuery({
    queryKey: ['userNotifications'],
    queryFn: async (): Promise<UserNotificationData> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_USER_ENGINE_ENDPOINT
        }/api/v1/bundles/user_bundle/functions/get_user_notifications`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'GET',
        }
      );

      let data = await response.json();

      return {
        notifications: data?.data?.notifications || [],
      };
    },
    enabled: keycloak.authenticated,
  });
}
